import { combineReducers } from 'redux';

import { default as adBudgetPurchased } from './adBudgetPurchased';
import { default as adBudgetValue } from './adBudgetValue';
import { default as addOnAdProductNames } from './addOnAdProductNames';
import { default as advertiser } from './advertiser';
import { default as autoClassifyCategoryChosen } from './autoClassifyCategoryChosen';
import { default as autoClassifyCategorySuggested } from './autoClassifyCategorySuggested';
import { default as cajaAboutBusinessCharacterCount } from './cajaAboutBusinessCharacterCount';
import { default as cajaFlowType } from './cajaFlowType';
import { default as cajaHasAIAssistanceBeenUsed } from './cajaHasAIAssistanceBeenUsed';
import { default as cajaPayType } from './cajaPayType';
import { default as cajaSalaryCurrency } from './cajaSalaryCurrency';
import { default as cajaWorkType } from './cajaWorkType';
import { default as cajaWorkplaceOption } from './cajaWorkplaceOption';
import { default as contractProductName } from './contractProductName';
import { default as contractProductSetProductId } from './contractProductSetProductId';
import { default as country } from './country';
import { default as discountCode } from './discountCode';
import { default as displayPay } from './displayPay';
import { default as draftId } from './draftId';
import { default as emailAddressVerified } from './emailAddressVerified';
import { default as experiments } from './experiments';
import { default as finalJobSummaryCharacterCount } from './finalJobSummaryCharacterCount';
import { default as hasCoverImage } from './hasCoverImage';
import { default as hasLogo } from './hasLogo';
import { default as hasSeenSuccess } from './hasSeenSuccess';
import { default as hasSufficientBudget } from './hasSufficientBudget';
import { default as hasWorkplaceOption } from './hasWorkplaceOption';
import { default as hirerAdPurchaser } from './hirerAdPurchaser';
import { default as hirerContract } from './hirerContract';
import { default as hirerInfo } from './hirerInfo';
import { default as hirerPurchaseType } from './hirerPurchaseType';
import { default as isLinkOutApplyViaSeek } from './isLinkOutApplyViaSeek';
import { default as isOnCreditHold } from './isOnCreditHold';
import { default as isPaidByStoredCreditCard } from './isPaidByStoredCreditCard';
import { default as isPayment } from './isPayment';
import { default as isPremiumAdOffered } from './isPremiumAdOffered';
import { default as isPrivateAd } from './isPrivateAd';
import isSaveCreditCardChecked from './isSaveCreditCardChecked';
import { default as jobAdClassification } from './jobAdClassification';
import { default as jobAdPostedWithRR } from './jobAdPostedWithRR';
import { default as jobAdSubClassification } from './jobAdSubClassification';
import { default as jobAdTypePosted } from './jobAdTypePosted';
import { default as jobAdTypeSelected } from './jobAdTypeSelected';
import { default as numberOfBenefits } from './numberOfBenefits';
import { default as numberOfQualifications } from './numberOfQualifications';
import { default as numberOfTasks } from './numberOfTasks';
import { default as orderNumber } from './orderNumber';
import { default as page } from './page';
import { default as paymentMediumSelected } from './paymentMediumSelected';
import { default as paymentMethod } from './paymentMethod';
import { default as previousPageName } from './previousPageName';
import { default as priceVisibility } from './priceVisibility';
import { default as productPricing } from './productPricing';
import { default as productSetId } from './productSetId';
import { default as productSetProductIds } from './productSetProductIds';
import { default as productTotalPrice } from './productTotalPrice';
import { default as recommendedSalaryRange } from './recommendedSalaryRange';
import { default as roleTitle } from './roleTitle';
import { default as rrNumberOfQuestions } from './rrNumberOfQuestions';
import { default as rrQuestionIds } from './rrQuestionIds';
import { default as salaryRangeSelected } from './salaryRangeSelected';
import { default as seekAdvertiserId } from './seekAdvertiserId';
import { default as seekListingId } from './seekListingId';
import { default as sourceJobId } from './sourceJobId';
import { default as testingId } from './testingId';
import { default as userId } from './userId';

export default combineReducers({
  adBudgetPurchased,
  adBudgetValue,
  addOnAdProductNames,
  advertiser,
  autoClassifyCategoryChosen,
  autoClassifyCategorySuggested,
  cajaAboutBusinessCharacterCount,
  cajaFlowType,
  cajaHasAIAssistanceBeenUsed,
  cajaPayType,
  cajaSalaryCurrency,
  cajaWorkType,
  cajaWorkplaceOption,
  contractProductName,
  contractProductSetProductId,
  country,
  discountCode,
  displayPay,
  draftId,
  emailAddressVerified,
  experiments,
  finalJobSummaryCharacterCount,
  hasCoverImage,
  hasLogo,
  hasSeenSuccess,
  hasSufficientBudget,
  hasWorkplaceOption,
  hirerAdPurchaser,
  hirerContract,
  hirerInfo,
  hirerPurchaseType,
  isLinkOutApplyViaSeek,
  isOnCreditHold,
  isPaidByStoredCreditCard,
  isPremiumAdOffered,
  isPrivateAd,
  isPayment,
  isSaveCreditCardChecked,
  jobAdClassification,
  jobAdPostedWithRR,
  jobAdSubClassification,
  jobAdTypePosted,
  jobAdTypeSelected,
  numberOfBenefits,
  numberOfQualifications,
  numberOfTasks,
  orderNumber,
  page,
  paymentMediumSelected,
  paymentMethod,
  previousPageName,
  priceVisibility,
  productPricing,
  productSetId,
  productSetProductIds,
  productTotalPrice,
  recommendedSalaryRange,
  roleTitle,
  rrNumberOfQuestions,
  rrQuestionIds,
  salaryRangeSelected,
  seekAdvertiserId,
  seekListingId,
  sourceJobId,
  testingId,
  userId,
});
